import { EnvFlags, UserFlags } from 'ha/constants/FeatureFlags';

export enum FeatureStatus {
  LOADING = 'loading',
  DISABLED = 'disabled',
  ENABLED = 'enabled',
}

export type RenderFn = (s: FeatureStatus) => JSX.Element | null;

export type FeatureFlags = UserFlags | EnvFlags;
